export default "__VITE_ASSET__70edoqoP__"